const formFields = [
  {
    id: 1,
    category: "acads-research-placement",
    heading: "Academics, Research & Placements",
    content:
      "academics, registrations, research labs and competitions / conferences going on, programs happening, Placements, Practice School",
  },
  {
    id: 2,
    category: "mess-hostel-amenities",
    heading: "Mess, Hostels and Amenities",
    content:
      "mess, hostels, amenties like malakar, hair cut, laundry, food outlets, Vending Machines etc.",
  },
  {
    id: 3,
    category: "security-initiatives-infrastructure",
    heading: "Security, Initiatives and Infrastructure",
    content: "security, infra, new initiatives in campus",
  },
  {
    id: 4,
    category: "fitness-health-sports",
    heading: "Fitness, Health and Sports",
    content: "related to MedC, Health issues, sports facilities,sac ",
  },
  {
    id: 5,
    category: "clubs-societies-departments",
    heading: "Clubs, Societies and Departments",
    content: "all queries related to Clubs, Depts, Independent Bodies, Fests",
  },
  {
    id: 6,
    category: "administrative-general",
    heading: "Administrative Machinery and General College Life",
  },
  {
    id: 7,
    category: "events",
    heading: "Events",
  },
];
export default formFields;
